import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=c31a7f92"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports